import { useEffect, useState } from "react";
import api from "@/lib/api";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { TrendingUp } from "lucide-react";

const COLORS = ["#1C3F39", "#D96C5B", "#7CA1B4", "#2A5C53", "#A8654F"];

export default function CompensationTrend() {
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get("/stats/compensation-trends?months=6").then(({ data }) => setData(data.data));
    }, []);

    if (!data) return null;
    if (!data.series?.length) {
        return (
            <div className="hl-card p-6" data-testid="trend-empty">
                <div className="flex items-center gap-2 mb-2">
                    <TrendingUp className="w-4 h-4 text-[#1C3F39]" />
                    <h2 className="font-display font-bold text-lg">Trend compenso</h2>
                </div>
                <p className="text-sm text-[#5C5C5C]">Non ci sono ancora abbastanza dati per mostrare i trend.</p>
            </div>
        );
    }

    // reshape into recharts-friendly array: [{month, "Prof1": avg, "Prof2": avg}, ...]
    const chartData = data.months.map(m => {
        const row = { month: m };
        for (const s of data.series) {
            const p = s.points.find(p => p.month === m);
            if (p?.avg != null) row[s.profession] = p.avg;
        }
        return row;
    });

    return (
        <div className="hl-card p-6" data-testid="trend-chart">
            <div className="flex items-center gap-2 mb-4">
                <TrendingUp className="w-4 h-4 text-[#1C3F39]" />
                <h2 className="font-display font-bold text-lg">Trend compenso lordo</h2>
                <span className="text-xs text-[#5C5C5C]">· ultimi 6 mesi</span>
            </div>
            <div className="w-full h-72">
                <ResponsiveContainer>
                    <LineChart data={chartData} margin={{ top: 8, right: 24, left: 0, bottom: 0 }}>
                        <CartesianGrid stroke="#E5E5E0" strokeDasharray="3 3" vertical={false} />
                        <XAxis dataKey="month" stroke="#5C5C5C" fontSize={11} />
                        <YAxis stroke="#5C5C5C" fontSize={11} tickFormatter={(v) => `€${v}`} />
                        <Tooltip
                            formatter={(v) => [`€${v?.toFixed?.(2) ?? v}`, ""]}
                            contentStyle={{ background: "#fff", border: "1px solid #E5E5E0", borderRadius: 8, fontSize: 12 }}
                        />
                        <Legend wrapperStyle={{ fontSize: 12 }} />
                        {data.series.map((s, i) => (
                            <Line key={s.profession} type="monotone" dataKey={s.profession}
                                stroke={COLORS[i % COLORS.length]} strokeWidth={2}
                                dot={{ r: 3 }} activeDot={{ r: 5 }} connectNulls />
                        ))}
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
